import RestApiModel from "@/api/Model/RestApiModel";
import { fisgApi } from '@/api';

class News extends RestApiModel {
  static getNews(authApplicationPK) {
    return fisgApi.get('/GetNews', { params: { AuthApplicationPK: authApplicationPK } });
  }
  static markNewsAsRead(authApplicationPK) {
    return fisgApi.get('/MarkNewsAsRead', { params: { AuthApplicationPK: authApplicationPK } });
  }
}

export default News;